export const educationLevel = [
    {
        value: "High School",
        label: "High School",
    },
    {
        value: "Diploma",
        label: "Diploma",
    },
    {
        value: "PG Diploma",
        label: "PG Diploma",
    },
    {
        value: "Bachelor's",
        label: "Bachelor's",
    },
    { value: "Master's", label: "Master's" },
    { value: "PhD", label: "PhD" },
];